import { idType, selectItemType } from '@src/types';
import { TableData } from '@uikit/Tables/types';

export const weekDays = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
};

export type coverageAreasType = selectItemType & {
  parents: { state: idType; county: idType; city: idType } | {};
};

export type CoverageAreaSliceType = {
  states: Array<coverageAreasType>;
  countries: Array<coverageAreasType>;
  cities: Array<coverageAreasType>;
  zipCodes: Array<coverageAreasType>;
  coverageAreaTableData: TableData;
  businessHoursTableData: Record<string, boolean> | null;
};

export const handleGetData = (
  state: Array<coverageAreasType>,
  payload: Array<coverageAreasType>,
  parents: coverageAreasType['parents']
) => {
  payload.forEach((el) => {
    if (!state.find((elem) => el.id === elem.id)) {
      state.push({
        ...el,
        parents,
      });
    }
  });
  return state;
};

export const handleRemoveData = (
  state: Array<coverageAreasType>,
  selected: Record<string, idType>
) => {
  const key = Object.keys(selected)[0];
  return state.filter(
    (elem: coverageAreasType) => elem.parents[key] !== selected[key]
  );
};
